<div class="modal-body">
  <div class="btn-close-container">
    <button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="modalService.dismiss('Cross click')"
    >
      Cerrar
    </button>
  </div>
  <div class="btn-register-container">
    <button class="btn-register" (click)="openRegisterForm()">
      Registrate al evento
    </button>
  </div>
  <a
    href="https://docs.google.com/forms/d/e/1FAIpQLSd6ALh5OuLMCE6D0FBPe0aDMNGwzfUIJu519Bn9RuCD5y71Uw/viewform"
    target="_blank"
  >
    <img [src]="'assets/img/flyer-evento.webp'" alt="flyer evento fibras" />
  </a>
  <div class="justify-content-center align-items-center">
    <button class="close-button" (click)="modalService.dismiss('Cross click')">
      Cerrar
    </button>
  </div>
</div>
